import React from "react";
import { toast } from "react-toastify";
import { IoIosCloseCircle, IoIosCheckmark } from "react-icons/io";

const Success = ({ message }) => (
  <div>
    <IoIosCheckmark style={{ fontSize: "2rem", marginRight: "10px" }} />
    <span>{message}</span>
  </div>
);

const Error = ({ message }) => (
  <div>
    <IoIosCloseCircle style={{ fontSize: "2rem", marginRight: "10px" }} />
    <span>{message}</span>
  </div>
);

export default function Toast(msg, type, lessImportant) {
  switch (type) {
    case "success":
      toast.success(<Success message={msg} />, {
        hideProgressBar: true,
        position: toast.POSITION.TOP_CENTER,
      });
      break;
    case "error":
      toast.error(<Error message={msg} />, {
        hideProgressBar: true,
        position: toast.POSITION.TOP_CENTER,
      });
      break;
    case "reg.success":
      toast.success(msg, {
        position: toast.POSITION.TOP_CENTER,
      });
      break;
    case "info":
    default:
      toast.info(msg, {
        position: lessImportant
          ? toast.POSITION.BOTTOM_RIGHT
          : toast.POSITION.TOP_CENTER,
      });
  }
}
